(function () {
  const ExportCSV = document.querySelector(".export-csv");
  const ExportImportdiv = document.querySelector(
    ".import-export-pharmacy-data"
  );
  const ImportCSV = document.querySelector("#upload-csv-button");
  const csvMessage = document.querySelector("#pharmacy-finder-modal-trigger");
  const modalMessage = document.querySelector(".message-text");

  if (ExportCSV) {
    ExportCSV.addEventListener("click", function (e) {
      e.preventDefault();
      csvMessage.click();
      glide_ajax_loader_show();
      ExportPharmacyCSV();
    });
  }

  
  if (ImportCSV) {
    ImportCSV.addEventListener("click", function (e) {
      e.preventDefault();
      csvMessage.click();
      glide_ajax_loader_show();
      ImportPharmacyCSV();
    });
  }

  function ExportPharmacyCSV() {
    // Ajax request
    let request = new XMLHttpRequest();
    request.open("POST", glide_custom_data.ajax_url, true);
    request.setRequestHeader(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=UTF-8"
    );

    request.responseType = "blob"; // Set response type to blob for file download

    request.onreadystatechange = () => {
      let errorFlag = false;
      if (request.readyState === 4 && request.status === 200) {
        const blob = new Blob([request.response], { type: "text/csv" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download =
          "Glide-Pharmacy-Export-" +
          new Date().toISOString().slice(0, 10) +
          ".csv";
        document.body.appendChild(link); // Append to body to make it clickable
        link.click();
        document.body.removeChild(link); // Remove link after clicking
        glide_ajax_loader_hide();
        modalMessage.innerHTML = "<p>CSV Exported Successfully</p>";
      } else if (request.readyState === 4) {
        //console.error('Error during AJAX request:', request.responseText);
        const reader = new FileReader();
        reader.onload = function () {
          console.error("Error:", reader.result);
        };
        var message = JSON.parse(reader.result);
        glide_ajax_loader_hide();
        modalMessage.innerHTML = "<p>No CSV data found for export</p>";
        //reader.readAsText(request.response); // Convert blob to text
        console.log(reader.readAsText(request.response));
      }
    };
    // Send the request
    const postData =
      `action=export_import_pharmacy&nonce=${encodeURIComponent(
        glide_custom_data.ajax_nonce
      )}` + "&exportData=exportData";
    request.send(postData);
  }

  function ImportPharmacyCSV() {
    //Getting the File Input
    const fileInput = document.getElementById("csv-file");
    const file = fileInput.files[0];

    if (!file) {
      // alert("Please select a CSV file.");
      csvMessage.click();
      glide_ajax_loader_hide();
      modalMessage.innerHTML = `<p>Please select a CSV file</p>`;
      return;
    }

    // Create FormData to handle file upload
    const formData = new FormData();
    formData.append("csv_file", file);
    formData.append("action", "export_import_pharmacy");
    formData.append("nonce", encodeURIComponent(glide_custom_data.ajax_nonce));
    formData.append("importData", "importCSVData");

    // Ajax request
    let request = new XMLHttpRequest();
    request.open("POST", glide_custom_data.ajax_url, true);

    request.onreadystatechange = function () {
      if (request.readyState === 4) {
        if (request.status === 200) {
          try {
            const response = JSON.parse(request.responseText);
            if (response) {
              glide_ajax_loader_hide();
              modalMessage.innerHTML = `<p>`+ response.data +`</p>`;
            }
          } catch (error) {
            console.error("Error parsing response:", error);
            glide_ajax_loader_hide();
            modalMessage.innerHTML = `<p>An error occurred <br>while importing the CSV.</p>`;
          }
        } else {
          console.error("AJAX error:", request.responseText);
          glide_ajax_loader_hide();
          modalMessage.innerHTML = `<p>An error occurred <br>while processing <br>the request.</p>`;
        }
      }
    };

    //Send the request with the FormData
    request.send(formData);
  }
})();
